(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quick-add-to-cart')) {
    customElements.define(
      'quick-add-to-cart',
      class QuickAddToCart extends HTMLElement {
        connectedCallback() {
          if (this.dataset.quickAdd !== 'true') return;

          this.form = this.querySelector('form');
          this.button = this.form.querySelector('button[type="submit"]');
          this.label = this.button.querySelector('[data-quick-add-label]');
          this.defaultLabel = this.label.textContent;

          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }

        handleSubmit(event) {
          event.preventDefault();

          if (this.button.disabled) return;

          // Only cart-drawer.liquid's own upsell/refill recommend cards live
          // inside <cart-drawer> — product-card.liquid/scent-card.liquid
          // usages elsewhere on the page don't, so cartDrawerEl is null there
          // and this shared busy gate is skipped entirely for them.
          const cartDrawerEl = this.closest('cart-drawer');
          if (cartDrawerEl && cartDrawerEl.busy) return;

          const variantId = this.form.querySelector('input[name="id"]').value;
          const stockIssue = window.StockLimits && window.StockLimits.check([{ id: variantId, quantity: 1 }]);
          if (stockIssue) {
            window.StockLimits.flash(this.label, stockIssue.message);
            return;
          }

          this.button.disabled = true;
          this.label.textContent = this.dataset.addingLabel;
          if (cartDrawerEl) cartDrawerEl.setBusy(true);

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
              sections: 'header',
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
            })
            .catch(() => {})
            .finally(() => {
              this.button.disabled = false;
              this.label.textContent = this.defaultLabel;
              if (cartDrawerEl) cartDrawerEl.setBusy(false);
            });
        }
      }
    );
  }

  if (!customElements.get('variant-quick-add')) {
    customElements.define(
      'variant-quick-add',
      class VariantQuickAdd extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.optionsPanel = this.querySelector('[data-variant-options]');
          this.addButton = this.querySelector('[data-variant-add-button]');
          this.label = this.addButton.querySelector('[data-quick-add-label]');
          this.defaultLabel = this.label.textContent;

          this.addEventListener('pointerenter', this.handlePointerEnter.bind(this));
          this.addEventListener('pointerleave', this.handlePointerLeave.bind(this));
          this.addButton.addEventListener('click', this.handleButtonClick.bind(this));
          document.addEventListener('click', this.handleOutsideClick.bind(this));
        }

        handlePointerEnter(event) {
          if (event.pointerType !== 'mouse') return;
          this.open();
        }

        handlePointerLeave(event) {
          if (event.pointerType !== 'mouse') return;
          this.close();
        }

        handleOutsideClick(event) {
          if (!this.contains(event.target)) this.close();
        }

        open() {
          this.classList.add('is-open');
          this.optionsPanel.inert = false;
        }

        close() {
          this.classList.remove('is-open');
          this.optionsPanel.inert = true;
        }

        handleButtonClick(event) {
          event.preventDefault();

          if (this.addButton.disabled) return;

          if (!this.classList.contains('is-open')) {
            this.open();
            return;
          }

          this.submitAdd();
        }

        submitAdd() {
          const selected = this.form.querySelector('input[name="id"]:checked');
          if (!selected) return;

          const stockIssue = window.StockLimits && window.StockLimits.check([{ id: selected.value, quantity: 1 }]);
          if (stockIssue) {
            window.StockLimits.flash(this.label, stockIssue.message);
            return;
          }

          this.addButton.disabled = true;
          this.label.textContent = this.dataset.addingLabel;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: selected.value, quantity: 1, sections: 'header' }),
          })
            .then((response) => response.json())
            .then((data) => {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
            })
            .catch(() => {})
            .finally(() => {
              this.addButton.disabled = false;
              this.label.textContent = this.defaultLabel;
              this.close();
            });
        }
      }
    );
  }

  if (!customElements.get('subscription-quick-add')) {
    customElements.define(
      'subscription-quick-add',
      class SubscriptionQuickAdd extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.optionsPanel = this.querySelector('[data-subscription-options]');
          this.sellingPlanInput = this.querySelector('[data-selling-plan-input]');
          this.sellingPlanSelect = this.querySelector('[data-selling-plan-select]');
          this.subscribePrice = this.querySelector('[data-subscribe-price]');
          this.purchaseOptionInputs = Array.from(this.querySelectorAll('[data-purchase-option]'));
          this.addButton = this.querySelector('[data-subscription-add-button]');
          this.addPrice = this.addButton.querySelector('[data-subscription-add-price]');
          this.defaultAddPrice = this.addPrice.innerHTML;
          this.label = this.addButton.querySelector('[data-quick-add-label]');
          this.defaultLabel = this.label.textContent;

          this.updateSubscribeOptionPrice();

          this.addEventListener('pointerenter', this.handlePointerEnter.bind(this));
          this.addEventListener('pointerleave', this.handlePointerLeave.bind(this));
          this.addButton.addEventListener('click', this.handleButtonClick.bind(this));
          this.purchaseOptionInputs.forEach((input) => {
            input.addEventListener('change', this.handleOptionChange.bind(this));
          });
          this.sellingPlanSelect.addEventListener('change', this.handleSellingPlanChange.bind(this));
          document.addEventListener('click', this.handleOutsideClick.bind(this));

          this.handleOptionChange();
        }

        handlePointerEnter(event) {
          if (event.pointerType !== 'mouse') return;
          this.open();
        }

        handlePointerLeave(event) {
          if (event.pointerType !== 'mouse') return;
          this.close();
        }

        handleOutsideClick(event) {
          if (!this.contains(event.target)) this.close();
        }

        open() {
          this.classList.add('is-open');
          this.optionsPanel.inert = false;
        }

        close() {
          this.classList.remove('is-open');
          this.optionsPanel.inert = true;
        }

        updateSubscribeOptionPrice() {
          this.subscribePrice.innerHTML = this.sellingPlanSelect.selectedOptions[0].dataset.priceHtml;
        }

        handleSellingPlanChange() {
          this.updateSubscribeOptionPrice();
          if (this.sellingPlanInput.value !== '') this.handleOptionChange();
        }

        handleOptionChange() {
          const selected = this.purchaseOptionInputs.find((input) => input.checked);
          if (!selected) return;

          if (selected.value === 'subscribe') {
            const option = this.sellingPlanSelect.selectedOptions[0];
            this.sellingPlanInput.value = option.value;
            this.addPrice.innerHTML = option.dataset.priceHtml;
          } else {
            this.sellingPlanInput.value = '';
            this.addPrice.innerHTML = this.defaultAddPrice;
          }

          this.addButton.removeAttribute('aria-disabled');
        }

        handleButtonClick(event) {
          event.preventDefault();

          if (this.addButton.disabled) return;

          if (!this.classList.contains('is-open')) {
            this.open();
            return;
          }

          if (this.addButton.getAttribute('aria-disabled') === 'true') return;

          this.submitAdd();
        }

        submitAdd() {
          const variantId = this.form.querySelector('input[name="id"]').value;
          const stockIssue = window.StockLimits && window.StockLimits.check([{ id: variantId, quantity: 1 }]);
          if (stockIssue) {
            window.StockLimits.flash(this.label, stockIssue.message);
            return;
          }

          this.addButton.disabled = true;
          this.label.textContent = this.dataset.addingLabel;

          const payload = {
            id: variantId,
            quantity: 1,
            sections: 'header',
          };
          if (this.sellingPlanInput.value !== '') payload.selling_plan = this.sellingPlanInput.value;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          })
            .then((response) => response.json())
            .then((data) => {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
            })
            .catch(() => {})
            .finally(() => {
              this.addButton.disabled = false;
              this.label.textContent = this.defaultLabel;
              this.purchaseOptionInputs.forEach((input) => {
                input.checked = input.value === 'subscribe';
              });
              this.handleOptionChange();
              this.close();
            });
        }
      }
    );
  }

  if (!customElements.get('cart-discount')) {
    customElements.define(
      'cart-discount',
      class CartDiscount extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('[data-discount-form]');
          this.input = this.form.querySelector('input[name="discount"]');
          this.button = this.form.querySelector('button[type="submit"]');
          this.errorEl = this.querySelector('[data-discount-error]');

          this.form.addEventListener('submit', this.handleSubmit.bind(this));
          this.addEventListener('click', this.handleClick.bind(this));
        }

        existingCodes() {
          return Array.from(this.querySelectorAll('[data-discount-code]')).map((pill) => pill.dataset.discountCode);
        }

        handleClick(event) {
          const removeButton = event.target.closest('[data-remove-discount]');
          if (!removeButton) return;

          event.preventDefault();

          const pill = removeButton.closest('[data-discount-code]');
          if (!pill) return;

          const codes = this.existingCodes().filter((code) => code !== pill.dataset.discountCode);
          this.updateDiscounts(codes);
        }

        handleSubmit(event) {
          event.preventDefault();

          const value = this.input.value.trim();
          if (!value) return;

          const codes = this.existingCodes();
          if (codes.includes(value)) return;

          this.updateDiscounts([...codes, value], value);
        }

        hasAutomaticDiscount(cart) {
          const isAutomatic = (application) => application && application.type === 'automatic';
          if ((cart.cart_level_discount_applications || []).some(isAutomatic)) return true;
          return (cart.items || []).some((item) =>
            (item.line_level_discount_allocations || []).some((allocation) =>
              isAutomatic(allocation.discount_application)
            )
          );
        }

        // Only dispatches `cart:updated` (which triggers cart-drawer's
        // scoped footer swap) on success. On an invalid code we show the
        // error locally instead — dispatching here too would trigger that
        // swap and immediately wipe the error message with the fresh,
        // error-agnostic server HTML, since this theme does a plain
        // outerHTML replace rather than a smarter DOM diff/morph.
        updateDiscounts(codes, submittedCode) {
          const cartDrawerEl = this.closest('cart-drawer');
          if (cartDrawerEl && cartDrawerEl.busy) return;

          this.button.disabled = true;
          this.errorEl.hidden = true;
          if (cartDrawerEl) cartDrawerEl.setBusy(true);

          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: codes.join(','), sections: 'header' }),
          })
            .then((response) => response.json())
            .then((data) => {
              const submittedResult =
                submittedCode && data.discount_codes
                  ? data.discount_codes.find((discount) => discount.code === submittedCode)
                  : null;

              if (submittedResult && submittedResult.applicable === false) {
                // Shopify doesn't say why a code was rejected. If the cart
                // already carries an automatic discount (e.g. the Starter
                // Pack one), the likeliest cause is that the two aren't set
                // to combine, so say that instead of "invalid".
                this.errorEl.textContent = this.hasAutomaticDiscount(data)
                  ? this.errorEl.dataset.errorAutomatic
                  : this.errorEl.dataset.errorDefault;
                this.errorEl.hidden = false;
                return;
              }

              this.input.value = '';
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
            })
            .catch(() => {})
            .finally(() => {
              this.button.disabled = false;
              if (cartDrawerEl) cartDrawerEl.setBusy(false);
            });
        }
      }
    );
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define(
      'cart-drawer',
      class CartDrawer extends HTMLElement {
        connectedCallback() {
          this.content = this.querySelector('.cart-drawer__content');
          this.busy = false;

          this.addEventListener('click', this.handleClick.bind(this));
          this.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') this.close();
          });

          this.cartLink = document.querySelector('.header__cart');
          if (this.cartLink) {
            this.cartLink.addEventListener('click', this.handleCartLinkClick.bind(this));
          }

          document.addEventListener('cart:updated', (event) => this.handleCartUpdated(event.detail));
          this.bindGlobalFormSubmit();
        }

        handleCartLinkClick(event) {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.open();
        }

        handleClick(event) {
          if (event.target.closest('[data-drawer-close]')) {
            this.close();
            return;
          }

          const row = event.target.closest('[data-line-key]');
          if (!row) return;

          if (event.target.closest('[data-quantity-decrease]')) {
            this.changeQuantity(row.dataset.lineKey, Number(row.dataset.quantity) - 1, row);
          } else if (event.target.closest('[data-quantity-increase]')) {
            // At the line's stock cap + is only aria-disabled (rendered by
            // cart-line-stock-max.liquid), so the press still lands here and
            // can explain why nothing happened.
            if (event.target.closest('[data-quantity-increase]').getAttribute('aria-disabled') === 'true') {
              const note = row.querySelector('[data-stock-note]');
              if (note) note.hidden = false;
              return;
            }
            this.changeQuantity(row.dataset.lineKey, Number(row.dataset.quantity) + 1, row);
          } else if (event.target.closest('[data-remove-item]')) {
            event.preventDefault();
            this.changeQuantity(row.dataset.lineKey, 0, row);
          }
        }

        setBusy(isBusy) {
          this.busy = isBusy;
          this.classList.toggle('is-busy', isBusy);
        }

        changeQuantity(lineKey, quantity, row) {
          if (this.busy) return;
          this.setBusy(true);
          if (row) row.classList.add('is-updating');

          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lineKey, quantity, sections: 'header' }),
          })
            .then((response) => response.json())
            .then((data) => {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
            })
            .catch(() => {})
            .finally(() => {
              this.setBusy(false);
            });
        }

        handleCartUpdated(data) {
          if (!data || !data.sections || !data.sections.header || !this.content) return;

          const parsed = new DOMParser().parseFromString(data.sections.header, 'text/html');

          // Scoped refresh: only swap the parts driven purely by `cart`
          // (title count, shipping progress, items list, checkout). The
          // Upsell Banner and the recommendation row are deliberately left
          // untouched — they depend on section settings (collection/image
          // pickers) that don't currently resolve when this section is
          // rendered through the cart AJAX endpoint's `sections` param
          // (works fine on a normal page load) — swapping them in here
          // would blank them out. See [[project_cart_drawer]] memory.
          const newTitle = parsed.querySelector('.cart-drawer__title');
          const oldTitle = this.content.querySelector('.cart-drawer__title');
          if (newTitle && oldTitle) oldTitle.textContent = newTitle.textContent;

          const newShipping = parsed.querySelector('.cart-drawer__shipping');
          const oldShipping = this.content.querySelector('.cart-drawer__shipping');
          if (newShipping && oldShipping) oldShipping.outerHTML = newShipping.outerHTML;

          const newItemsWrap = parsed.querySelector('.cart-drawer__items, .cart-drawer__empty');
          const oldItemsWrap = this.content.querySelector('.cart-drawer__items, .cart-drawer__empty');
          if (newItemsWrap && oldItemsWrap) oldItemsWrap.outerHTML = newItemsWrap.outerHTML;

          const newFooter = parsed.querySelector('.cart-drawer__footer');
          const oldFooter = this.content.querySelector('.cart-drawer__footer');
          if (newFooter && oldFooter) {
            oldFooter.outerHTML = newFooter.outerHTML;
          } else if (newFooter && !oldFooter) {
            this.content.insertAdjacentHTML('beforeend', newFooter.outerHTML);
          } else if (!newFooter && oldFooter) {
            oldFooter.remove();
          }

          const newCartLink = parsed.querySelector('.header__cart');
          if (newCartLink && this.cartLink) this.cartLink.innerHTML = newCartLink.innerHTML;

          this.open();
        }

        bindGlobalFormSubmit() {
          if (window.cartDrawerFormBound) return;
          window.cartDrawerFormBound = true;

          document.addEventListener('submit', (event) => {
            if (event.defaultPrevented) return;

            const form = event.target;
            if (!(form instanceof HTMLFormElement)) return;
            if (!form.action.includes('/cart/add')) return;

            event.preventDefault();

            // `.form` (not `form.querySelector`) so this also catches buttons
            // associated via the `form="..."` attribute instead of DOM
            // nesting — e.g. product-gift-card-recipient-form.liquid's own
            // add-to-cart button, which lives outside this <form> in the DOM.
            const submitButtons = Array.from(document.querySelectorAll('[data-add-to-cart-button]')).filter(
              (button) => button.form === form
            );
            const labelStates = submitButtons.map((button) => {
              const label = button.querySelector('[data-add-to-cart-label]');
              return { button, label, defaultText: label ? label.textContent : null };
            });

            const formData = new FormData(form);
            const variantId = formData.get('id');
            const stockIssue =
              variantId &&
              window.StockLimits &&
              window.StockLimits.check([{ id: variantId, quantity: Number(formData.get('quantity')) || 1 }]);
            if (stockIssue) {
              // Card forms without a JS quick-add have no
              // [data-add-to-cart-button]; flash their own label instead.
              const labels = labelStates.length
                ? labelStates.map(({ label }) => label)
                : [form.querySelector('[data-quick-add-label]')];
              labels.forEach((label) => window.StockLimits.flash(label, stockIssue.message));
              return;
            }

            submitButtons.forEach((button) => {
              button.disabled = true;
            });
            labelStates.forEach(({ button, label }) => {
              if (label && button.dataset.addingLabel) label.textContent = button.dataset.addingLabel;
            });

            formData.append('sections', 'header');

            fetch('/cart/add.js', { method: 'POST', body: formData })
              .then((response) => response.json())
              .then((data) => {
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
              })
              .catch(() => {})
              .finally(() => {
                submitButtons.forEach((button) => {
                  button.disabled = false;
                });
                labelStates.forEach(({ label, defaultText }) => {
                  if (label && defaultText) label.textContent = defaultText;
                });
              });
          });
        }

        open() {
          this.inert = false;
          this.setAttribute('open', '');
          document.body.style.overflow = 'hidden';
        }

        close() {
          this.inert = true;
          this.removeAttribute('open');
          document.body.style.overflow = '';
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nav-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nav-drawer')) {
    customElements.define(
      'nav-drawer',
      class NavDrawer extends HTMLElement {
        connectedCallback() {
          this.panels = Array.from(this.querySelectorAll('[data-nav-panel]'));
          this.content = this.querySelector('.nav-drawer__content');
          this.backButton = this.querySelector('[data-nav-back]');
          this.activeTrigger = null;
          this.currentPanel = null;
          this.panelStack = [];
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.aside = this.querySelector('.nav-drawer__aside');
          this.flyoutItems = Array.from(this.querySelectorAll('[data-nav-flyout-target]'));
          this.flyoutTriggers = Array.from(this.querySelectorAll('[data-nav-flyout-trigger]'));
          this.activeFlyout = null;
          this.hideFlyoutTimeout = null;
          this.flyoutMql = window.matchMedia('(min-width: 900px)');

          this.flyoutTriggers.forEach((trigger) => {
            trigger.addEventListener('mouseenter', () => this.showFlyout(trigger.dataset.navFlyoutTrigger, trigger));
            trigger.addEventListener('mouseleave', () => this.scheduleHideFlyout());
            trigger.addEventListener('focus', () => this.showFlyout(trigger.dataset.navFlyoutTrigger, trigger));
            trigger.addEventListener('blur', () => this.scheduleHideFlyout());
          });

          if (this.aside) {
            this.aside.addEventListener('mouseenter', () => this.cancelHideFlyout());
            this.aside.addEventListener('mouseleave', () => this.scheduleHideFlyout());
          }

          this.addEventListener('click', this.handleClick.bind(this));
          this.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') this.close();
          });

          this.hamburger = document.querySelector('[data-nav-drawer-toggle]');
          if (this.hamburger) {
            this.hamburger.addEventListener('click', this.handleHamburgerClick.bind(this));
          }

          this.desktopTriggers = Array.from(document.querySelectorAll('[data-nav-trigger]'));
          this.desktopTriggers.forEach((trigger) => {
            trigger.addEventListener('click', this.handleDesktopTriggerClick.bind(this, trigger));
          });
        }

        handleHamburgerClick() {
          if (this.hasAttribute('open') && this.currentPanel === 'root') {
            this.close();
            return;
          }

          this.setActiveTrigger(null);
          this.resetToPanel('root');
          this.open();
        }

        handleDesktopTriggerClick(trigger, event) {
          event.preventDefault();

          if (this.hasAttribute('open') && this.activeTrigger === trigger) {
            this.close();
            return;
          }

          this.setActiveTrigger(trigger);
          this.resetToPanel(trigger.dataset.navTrigger);
          this.open();
        }

        setActiveTrigger(trigger) {
          if (this.activeTrigger) this.activeTrigger.classList.remove('is-active');
          this.activeTrigger = trigger || null;
          if (trigger) trigger.classList.add('is-active');
        }

        handleClick(event) {
          if (event.target.closest('[data-drawer-close]')) {
            this.close();
            return;
          }

          if (event.target.closest('[data-nav-back]')) {
            this.goBack();
            return;
          }

          const opener = event.target.closest('[data-nav-open]');
          if (opener) {
            event.preventDefault();
            this.drillInto(opener.dataset.navOpen);
            return;
          }

          // This trigger is a real `<a href>` now (see nav-drawer-panel.liquid)
          // so its children stay reachable by navigating on desktop. Below
          // 900px there's no other way to reach them (hover doesn't exist),
          // so the click is redirected into the inline toggle instead.
          const accordionToggle = event.target.closest('[data-nav-accordion-toggle]');
          if (accordionToggle && !this.flyoutMql.matches) {
            event.preventDefault();
            this.toggleAccordion(accordionToggle);
          }
        }

        toggleAccordion(toggle) {
          const panel = toggle.nextElementSibling;
          if (!panel) return;

          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!isExpanded));

          if (this.reduceMotion) {
            panel.hidden = isExpanded;
            return;
          }

          if (isExpanded) {
            this.collapseAccordionPanel(panel);
          } else {
            this.expandAccordionPanel(panel);
          }
        }

        expandAccordionPanel(panel) {
          if (panel._navAnimation) panel._navAnimation.cancel();

          panel.hidden = false;
          const endHeight = panel.scrollHeight;
          panel._navAnimation = panel.animate(
            { height: ['0px', `${endHeight}px`] },
            { duration: 250, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
          );
          panel._navAnimation.onfinish = () => {
            panel.style.height = '';
            panel._navAnimation = null;
          };
        }

        collapseAccordionPanel(panel) {
          if (panel._navAnimation) panel._navAnimation.cancel();

          const startHeight = panel.offsetHeight;
          panel._navAnimation = panel.animate(
            { height: [`${startHeight}px`, '0px'] },
            { duration: 200, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
          );
          panel._navAnimation.onfinish = () => {
            panel.hidden = true;
            panel.style.height = '';
            panel._navAnimation = null;
          };
        }

        // Desktop-only (see toggleAccordion) counterpart to the mobile inline
        // accordion: hovering/focusing a [data-nav-flyout-trigger] cross-fades
        // its [data-nav-flyout-target] panel in over header-menu-promo instead
        // of expanding anything inline. `trigger` is optional — hideFlyout()
        // (called with no args) just clears whatever is currently active.
        showFlyout(id, trigger) {
          if (!this.flyoutMql.matches) return;
          this.cancelHideFlyout();
          if (this.activeFlyout === id) return;

          const next = this.flyoutItems.find((item) => item.dataset.navFlyoutTarget === id);
          if (!next) return;

          this.flyoutItems.forEach((item) => {
            if (item !== next) this.deactivateFlyoutItem(item);
          });

          this.flyoutTriggers.forEach((candidate) => {
            candidate.setAttribute('aria-expanded', String(candidate === trigger));
          });

          next.hidden = false;
          // Force layout so the removed `hidden` is committed before the
          // opacity transition below is triggered — otherwise the browser
          // can coalesce the two and skip straight to the end state.
          next.getBoundingClientRect();
          next.classList.add('is-active');
          if (this.aside) this.aside.classList.add('has-flyout-active');
          this.activeFlyout = id;
        }

        scheduleHideFlyout() {
          if (!this.activeFlyout) return;
          this.cancelHideFlyout();
          this.hideFlyoutTimeout = window.setTimeout(() => this.hideFlyout(), 150);
        }

        cancelHideFlyout() {
          if (this.hideFlyoutTimeout) {
            window.clearTimeout(this.hideFlyoutTimeout);
            this.hideFlyoutTimeout = null;
          }
        }

        hideFlyout() {
          this.cancelHideFlyout();
          if (!this.activeFlyout) return;

          this.activeFlyout = null;
          if (this.aside) this.aside.classList.remove('has-flyout-active');
          this.flyoutTriggers.forEach((candidate) => candidate.setAttribute('aria-expanded', 'false'));
          this.flyoutItems.forEach((item) => this.deactivateFlyoutItem(item));
        }

        deactivateFlyoutItem(item) {
          if (item.hidden) return;

          item.classList.remove('is-active');

          if (this.reduceMotion) {
            item.hidden = true;
            return;
          }

          const onTransitionEnd = (event) => {
            if (event.target !== item || event.propertyName !== 'opacity') return;
            item.removeEventListener('transitionend', onTransitionEnd);
            if (!item.classList.contains('is-active')) item.hidden = true;
          };
          item.addEventListener('transitionend', onTransitionEnd);
        }

        // Fresh entry point (a trigger was clicked): forget any previous drill-in path.
        // No slide animation here — this can jump between unrelated top-level
        // triggers, not just move one level deeper/shallower.
        resetToPanel(panelId) {
          this.panelStack = [];
          this.showPanel(panelId, null);
        }

        // One level deeper: remember where we came from so "back" can return to it.
        drillInto(panelId) {
          if (this.currentPanel) this.panelStack.push(this.currentPanel);
          this.showPanel(panelId, 'forward');
        }

        goBack() {
          const previous = this.panelStack.pop();
          if (previous) this.showPanel(previous, 'backward');
        }

        // A trigger from a panel that's about to be hidden can't fire its own
        // mouseleave/blur (the panel-swap animation below moves it out from
        // under the cursor/focus without a real pointer/focus event), so any
        // flyout it left showing has to be cleared explicitly on every switch.
        showPanel(panelId, direction) {
          this.hideFlyout();

          const outgoing = this.panels.find((panel) => panel.dataset.navPanel === this.currentPanel);
          const incoming = this.panels.find((panel) => panel.dataset.navPanel === panelId);
          this.currentPanel = panelId;
          if (this.backButton) this.backButton.hidden = this.panelStack.length === 0;

          if (!direction || !outgoing || !incoming || outgoing === incoming || this.reduceMotion) {
            // Drop any in-flight height animation from an interrupted drill
            // so it doesn't leave .nav-drawer__content pinned to a stale height.
            if (this.content && this.content._navAnimation) {
              this.content._navAnimation.cancel();
              this.content._navAnimation = null;
              this.content.style.height = '';
            }
            this.panels.forEach((panel) => {
              panel.hidden = panel.dataset.navPanel !== panelId;
            });
            return;
          }

          this.animatePanelSwap(outgoing, incoming, direction);
        }

        // Slides the outgoing panel out, then slides the incoming panel in
        // from the opposite side — drilling in moves right-to-left, going
        // back retraces left-to-right, so the motion reads as one
        // continuous level of navigation rather than a hard cut. Runs a
        // matching height animation on .nav-drawer__content at the same
        // time, since the two panels are rarely the same height — without
        // it, .nav-drawer__content's box (and header-menu-promo, which
        // stretches to match it) would snap to the new size the instant
        // the panels swap instead of easing there alongside the slide.
        animatePanelSwap(outgoing, incoming, direction) {
          const exitClass = direction === 'forward' ? 'nav-drawer__panel-list--exit-forward' : 'nav-drawer__panel-list--exit-backward';
          const enterClass = direction === 'forward' ? 'nav-drawer__panel-list--enter-forward' : 'nav-drawer__panel-list--enter-backward';
          const content = this.content;
          const startHeight = content ? content.offsetHeight : null;

          outgoing.classList.add(exitClass);

          window.setTimeout(() => {
            outgoing.hidden = true;
            outgoing.classList.remove(exitClass);

            incoming.hidden = false;
            incoming.classList.add(enterClass);

            let endHeight = null;
            if (content && startHeight !== null) {
              // Read the new natural height immediately (before pinning
              // anything below), then pin back to the old height so the
              // swap doesn't flash straight to it — the WAAPI animation
              // eases between the two instead, one frame later.
              endHeight = content.offsetHeight;
              if (content._navAnimation) content._navAnimation.cancel();
              content.style.height = `${startHeight}px`;
            }

            // Force layout so the entering panel's starting offset (and the
            // pinned start height above) are committed before the styles
            // below run — otherwise the browser can coalesce all of these
            // style changes and skip the transitions entirely.
            incoming.getBoundingClientRect();

            window.requestAnimationFrame(() => {
              incoming.classList.remove(enterClass);

              if (content && endHeight !== null && endHeight !== startHeight) {
                content._navAnimation = content.animate(
                  { height: [`${startHeight}px`, `${endHeight}px`] },
                  { duration: 150, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
                );
                content._navAnimation.onfinish = () => {
                  content.style.height = '';
                  content._navAnimation = null;
                };
              } else if (content) {
                content.style.height = '';
              }
            });
          }, 150);
        }

        open() {
          this.inert = false;
          this.setAttribute('open', '');
          document.body.style.overflow = 'hidden';
        }

        close() {
          this.inert = true;
          this.removeAttribute('open');
          document.body.style.overflow = '';
          this.setActiveTrigger(null);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-candle-holder-drawer"] && !Shopify.designMode) return;
  try {
    // Holder size switch: hide while the customer scrolls the panel up, show
  // again as soon as they scroll down. Always shown at the very end of the
  // list and whenever it has keyboard focus. The list scrolls inside
  // __scroll; the switch is pinned to the bottom of the panel.
  const initHolderSizeSwitches = () => document.querySelectorAll('.product-candle-holder-drawer__size-switch').forEach((sizeSwitch) => {
    const scroller = sizeSwitch.closest('.product-candle-holder-drawer__panel')?.querySelector('.product-candle-holder-drawer__scroll');
    if (!scroller) return;

    // Pad the end of the list by the switch's height so the last cards can
    // scroll clear of it.
    new ResizeObserver(() => {
      scroller.style.setProperty('--size-switch-height', `${sizeSwitch.offsetHeight}px`);
    }).observe(sizeSwitch);

    const hiddenClass = 'product-candle-holder-drawer__size-switch--hidden';
    let lastScrollTop = scroller.scrollTop;

    scroller.addEventListener('scroll', () => {
      const scrollTop = scroller.scrollTop;
      const delta = scrollTop - lastScrollTop;
      // Ignore tiny jitters (and iOS bounce) so it doesn't flicker.
      if (Math.abs(delta) < 4) return;
      lastScrollTop = scrollTop;

      const atEnd = scrollTop + scroller.clientHeight >= scroller.scrollHeight - 2;
      sizeSwitch.classList.toggle(hiddenClass, delta < 0 && !atEnd);
    }, { passive: true });

    sizeSwitch.addEventListener('focusin', () => sizeSwitch.classList.remove(hiddenClass));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHolderSizeSwitches);
  } else {
    initHolderSizeSwitches();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-card-slider')) {
    class ProductCardSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.product-card__slider-track');
        this.slides = Array.from(this.querySelectorAll('.product-card__slide'));
        this.prevButton = this.querySelector('[data-direction="prev"]');
        this.nextButton = this.querySelector('[data-direction="next"]');
        this.index = 0;
        this.animation = this.dataset.animation === 'fade' ? 'fade' : 'slide';

        // On a card inside a scroll-snap carousel (e.g. featured-collection),
        // tapping a button focuses it, and the browser's default "scroll
        // focused element into view" kicks in scroll-snap-type on the
        // ancestor track — snapping the whole carousel to the next card.
        // Blocking focus on pointerdown (not click, which fires after focus
        // already happened) heads that off; keyboard access is unaffected
        // since Tab doesn't dispatch pointerdown.
        [this.prevButton, this.nextButton].forEach((button) => {
          button.addEventListener('pointerdown', (event) => event.preventDefault());
        });

        this.prevButton.addEventListener('click', (event) => {
          event.preventDefault();
          this.goTo(this.index - 1);
        });
        this.nextButton.addEventListener('click', (event) => {
          event.preventDefault();
          this.goTo(this.index + 1);
        });

        // Listen on the shared ancestor, not `this` — the image-link overlay sits
        // above this element in stacking, so hover here would only fire over the
        // nav buttons and loop when hiding one moved the hit-test target underneath.
        this.hoverTarget = this.closest('.product-card__image');
        this.hoverTarget.addEventListener('pointerenter', this.handlePointerEnter.bind(this));
        this.hoverTarget.addEventListener('pointerleave', this.handlePointerLeave.bind(this));
      }

      handlePointerEnter(event) {
        if (event.pointerType !== 'mouse') return;
        this.goTo(this.index + 1);
      }

      handlePointerLeave(event) {
        if (event.pointerType !== 'mouse') return;
        this.goTo(0);
      }

      goTo(index) {
        this.index = Math.max(0, Math.min(index, this.slides.length - 1));
        if (this.animation === 'fade') {
          this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.index));
        } else {
          this.track.style.transform = `translateX(-${this.index * 100}%)`;
        }
        this.prevButton.hidden = this.index <= 0;
        this.nextButton.hidden = this.index >= this.slides.length - 1;
      }
    }

    customElements.define('product-card-slider', ProductCardSlider);
  }

  // `quick-add-to-cart`, `subscription-quick-add`, and `variant-quick-add`
  // are defined once in snippets/cart-drawer.liquid (rendered from the
  // header on every page) so they're always registered before this markup
  // needs them — see that file's doc comment for why they don't live here.
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-colour-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-colour-selector')) {
    customElements.define(
      'product-colour-selector',
      class ProductColourSelector extends HTMLElement {
        connectedCallback() {
          this.valueLabel = this.querySelector('[data-selected-value]');
          this.addEventListener('change', (event) => {
            const input = event.target;
            if (input.name === 'id' && input.dataset.label && this.valueLabel) {
              this.valueLabel.textContent = input.dataset.label;
            }
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gift-card-denomination-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gift-card-denomination-picker')) {
    customElements.define(
      'gift-card-denomination-picker',
      class GiftCardDenominationPicker extends HTMLElement {
        connectedCallback() {
          this.addEventListener('change', (event) => {
            if (event.target.type !== 'radio') return;
            const formattedPrice = event.target.dataset.formattedPrice;
            if (formattedPrice === undefined) return;
            document.dispatchEvent(
              new CustomEvent('gift-card-denomination:changed', { detail: { formattedPrice } })
            );
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gift-option-drawer"] && !Shopify.designMode) return;
  try {
    if (!window.giftOptionDrawersBound) {
    window.giftOptionDrawersBound = true;

    const initGiftOptionDrawer = (drawer) => {
      const toggles = drawer.querySelectorAll('[data-gift-toggle]');
      const messageInput = drawer.querySelector('[data-gift-message-input]');
      const saveButton = drawer.querySelector('[data-gift-save]');
      if (!toggles.length || !saveButton) return;

      // Mirrors the shared product-drawer syncTriggerLabel(): write the
      // chosen label back into the "It's a gift?" card's choose button.
      const setTriggerLabel = (text) => {
        document
          .querySelectorAll(`[data-drawer-open="${drawer.id}"] [data-drawer-choice-label]`)
          .forEach((el) => {
            el.textContent = text;
          });
      };

      const clearArmed = () => {
        delete drawer.dataset.giftArmed;
        delete drawer.dataset.giftMessage;
      };

      toggles.forEach((input) => {
        input.addEventListener('change', () => {
          // "It's a gift": stay open — CSS reveals the message + Save step.
          if (input.value === 'yes') return;
          // "Just for me": nothing to bundle. Drop any armed gift and
          // pick-and-close like the scent/discovery drawers do.
          clearArmed();
          setTriggerLabel(drawer.dataset.justForMeLabel || '');
          if (typeof drawer.close === 'function') drawer.close();
        });
      });

      // Save arms the gift: product-purchase-options.liquid's submitBundle()
      // reads data-gift-armed / data-gift-message off this element and adds
      // the gift-bag product (one-time) to the main add-to-cart request.
      saveButton.addEventListener('click', () => {
        drawer.dataset.giftArmed = 'true';
        drawer.dataset.giftMessage = messageInput ? messageInput.value.trim() : '';
        setTriggerLabel(drawer.dataset.itsAGiftLabel || '');
        if (typeof drawer.close === 'function') drawer.close();
      });

      // On load, reflect the pre-checked radio ("Just for me") into the
      // trigger card so it never shows the "Choose" placeholder. The Liquid
      // already renders this label; this keeps the two in lockstep if the
      // default changes.
      const syncFromCheckedToggle = () => {
        const checkedToggle = drawer.querySelector('[data-gift-toggle]:checked');
        if (!checkedToggle) return;
        setTriggerLabel(
          checkedToggle.value === 'yes'
            ? drawer.dataset.itsAGiftLabel || ''
            : drawer.dataset.justForMeLabel || ''
        );
      };
      syncFromCheckedToggle();

      // <product-drawer>.reset() has already put the toggles back to
      // "Just for me" — also disarm the gift and empty the message.
      drawer.addEventListener('drawer:reset', () => {
        clearArmed();
        if (messageInput) messageInput.value = messageInput.defaultValue;
        syncFromCheckedToggle();
      });
    };

    const initAll = () => {
      document.querySelectorAll('.product-gift-option-drawer').forEach(initGiftOptionDrawer);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-gallery')) {
    customElements.define(
      'product-gallery',
      class ProductGallery extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.product-media__thumbnail-track');
          this.prevButton = this.querySelector('[data-direction="prev"]');
          this.nextButton = this.querySelector('[data-direction="next"]');
          this.thumbnails = Array.from(this.querySelectorAll('.product-media__thumbnail'));
          this.mainItems = Array.from(this.querySelectorAll('.product-media__main-item'));
          this.desktopQuery = window.matchMedia('(min-width: 999px)');

          this.thumbnails.forEach((thumbnail) => {
            thumbnail.addEventListener('click', () => this.setActive(thumbnail.dataset.index));
          });

          const activeItem = this.mainItems.find((item) => item.classList.contains('product-media__main-item--active'));
          if (activeItem) this.trackImageLoad(activeItem);

          if (this.track) {
            this.querySelectorAll('[data-direction]').forEach((button) => {
              button.addEventListener('click', () => {
                const isDesktop = this.desktopQuery.matches;
                const thumbnail = this.thumbnails[0];
                const distance = thumbnail
                  ? thumbnail.getBoundingClientRect()[isDesktop ? 'height' : 'width'] + 12
                  : this.track[isDesktop ? 'clientHeight' : 'clientWidth'];
                const direction = button.dataset.direction === 'prev' ? -1 : 1;
                this.track.scrollBy({ [isDesktop ? 'top' : 'left']: distance * direction, behavior: 'smooth' });
              });
            });

            this.updateNavButtons();
            this.track.addEventListener('scroll', () => this.updateNavButtons(), { passive: true });
            window.addEventListener('resize', () => this.updateNavButtons());
          }
        }

        setActive(index) {
          this.thumbnails.forEach((thumbnail) => {
            thumbnail.classList.toggle('product-media__thumbnail--active', thumbnail.dataset.index === index);
          });
          this.mainItems.forEach((item) => {
            const isActive = item.dataset.index === index;
            item.classList.toggle('product-media__main-item--active', isActive);
            if (isActive) this.trackImageLoad(item);
          });
        }

        trackImageLoad(item) {
          const img = item.querySelector('img');
          if (!img) return;

          if (img.complete) {
            item.classList.remove('product-media__main-item--loading');
            return;
          }

          item.classList.add('product-media__main-item--loading');
          const onSettle = () => {
            item.classList.remove('product-media__main-item--loading');
            img.removeEventListener('load', onSettle);
            img.removeEventListener('error', onSettle);
          };
          img.addEventListener('load', onSettle);
          img.addEventListener('error', onSettle);
        }

        updateNavButtons() {
          const isDesktop = this.desktopQuery.matches;
          const scrollPos = this.track[isDesktop ? 'scrollTop' : 'scrollLeft'];
          const maxScroll = isDesktop
            ? this.track.scrollHeight - this.track.clientHeight
            : this.track.scrollWidth - this.track.clientWidth;
          if (this.prevButton) this.prevButton.disabled = scrollPos <= 0;
          if (this.nextButton) this.nextButton.disabled = scrollPos >= maxScroll - 1;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-purchase-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-purchase-form')) {
    customElements.define(
      'product-purchase-form',
      class ProductPurchaseForm extends HTMLElement {
        connectedCallback() {
          this.isStarterPack = this.dataset.purchaseMode === 'starter_pack';
          this.isRefillBundle = this.dataset.purchaseMode === 'refill_bundle';

          // "subscribe" mode (Candle Refills): no bundling or add-to-cart
          // gating — keep the form's selling_plan field in sync with the
          // chosen purchase option (and, when shown, the frequency
          // <select>), then let the form submit normally.
          if (this.dataset.purchaseMode === 'subscribe') {
            this.sellingPlanInput = this.querySelector('[data-selling-plan-input]');
            this.frequencySelect = this.querySelector('[data-frequency-select]');
            this.subscribePriceEl = this.querySelector('[data-subscribe-price]');
            this.purchaseOptionInputs = Array.from(this.querySelectorAll('.product-purchase__option-input'));
            this.purchaseOptionInputs.forEach((input) => {
              input.addEventListener('change', () => this.syncSellingPlan());
            });
            if (this.frequencySelect) {
              // A <select> is interactive content, so a click on it should
              // not activate the wrapping option <label> — stop it here so
              // the only path that touches the radio is the change handler.
              this.frequencySelect.addEventListener('click', (event) => event.stopPropagation());
              this.frequencySelect.addEventListener('change', () => {
                const subscribeInput = this.purchaseOptionInputs.find((input) => input.value === 'subscribe');
                if (subscribeInput && !subscribeInput.checked) {
                  subscribeInput.checked = true;
                  subscribeInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
                this.syncSellingPlan();
              });
            }
            this.syncSellingPlan();
            return;
          }

          if (this.isRefillBundle) {
            this.initRefillBundle();
            return;
          }

          if (this.dataset.purchaseMode !== 'bundle' && !this.isStarterPack) return;

          this.form = this.closest('form');
          // Both bundle and Starter Pack modes render a single checkout row
          // (below the builder grid), but keep the add-to-cart
          // button/label handling list-based as a guard; defaultAddLabel
          // comes from the first.
          this.addButtons = Array.from(this.querySelectorAll('[data-add-to-cart-button]'));
          this.addButton = this.addButtons[0];
          this.addLabels = this.addButtons.map((button) => button.querySelector('[data-add-to-cart-label]'));
          this.addLabel = this.addLabels[0];
          this.defaultAddLabel = this.addLabel.textContent;
          this.purchaseOptionInputs = Array.from(this.querySelectorAll('.product-purchase__option-input'));

          // Keep every quantity stepper in the form in sync so whichever
          // add button the customer uses reads the same quantity.
          this.quantityInputs = Array.from(this.form.querySelectorAll('input[name="quantity"]'));
          this.quantityInputs.forEach((input) => {
            input.addEventListener('change', () => {
              this.quantityInputs.forEach((other) => {
                if (other !== input) other.value = input.value;
              });
            });
          });

          this.refillDrawer = document.getElementById('candle-refill-scent-drawer');
          this.discoverySetDrawer = document.getElementById('discovery-set-drawer');
          this.holderDrawer = this.isStarterPack ? document.getElementById('candle-holder-drawer') : null;

          this.purchaseOptionInputs.forEach((input) => {
            input.addEventListener('change', () => this.updateGating());
          });
          this.bindDrawer(this.refillDrawer);
          this.bindDrawer(this.discoverySetDrawer);
          this.bindDrawer(this.holderDrawer);

          this.holderImageWrap = this.querySelector('[data-holder-image]');
          this.refillImageWrap = this.querySelector('[data-refill-image]');
          this.rememberCardImages([this.holderImageWrap, this.refillImageWrap]);

          // Starter Pack only: the "One-time" option's price span, kept in
          // sync with the chosen holder + refill + Discovery Set total by updateOneTimePrice
          // — except on the Extra-Large Starter Pack, where
          // updateExtraLargePricing() owns it instead (see below).
          this.oneTimePriceEl = this.querySelector('[data-one-time-price]');

          // Extra-Large Starter Pack only: both option prices are a flat
          // two-tier figure keyed by the chosen holder (Blue Onyx vs every
          // other extra-large vessel) — see updateExtraLargePricing().
          this.isExtraLargeStarterPack = this.hasAttribute('data-extra-large-starter-pack');
          this.blueOnyxHandle = this.dataset.blueOnyxHandle;
          this.experiencePriceEl = this.querySelector('[data-experience-price]');

          // Regular Starter Pack only: the Candle Experience price follows
          // the chosen holder's build_your_set.price — see
          // updateExperiencePrice().
          this.hasHolderExperiencePrice = this.hasAttribute('data-holder-experience-price');

          // Starter Pack only: the Candle Experience option's struck-through
          // figure mirrors the "One-time" price — see syncExperienceCompare().
          this.experienceComparePriceEl = this.isStarterPack
            ? this.querySelector('[data-experience-compare-price]')
            : null;

          if (this.holderDrawer) {
            this.holderDrawer.addEventListener('change', (event) => {
              if (event.target.type !== 'radio') return;
              this.dispatchHolderChanged(event.target);
              this.syncCardImage(this.holderImageWrap, event.target.dataset.productImage);
            });

            const checkedHolder = this.holderDrawer.querySelector('input[type="radio"]:checked');
            if (checkedHolder) this.syncCardImage(this.holderImageWrap, checkedHolder.dataset.productImage);
          }

          if (this.refillDrawer) {
            this.refillDrawer.addEventListener('change', (event) => {
              if (event.target.type !== 'radio') return;
              this.syncCardImage(this.refillImageWrap, event.target.dataset.productImage);
              // Tell the dynamic accordion rows which refill was picked.
              // Starter Pack: the radio value is a
              // candle-refill-starterpack variant id → the "Scent Notes"
              // row (blocks/product-scent-notes-accordion.liquid).
              // Candle Holders "bundle" mode: the radio value is the chosen
              // refill PRODUCT's first variant id → the "Burn time" row
              // (blocks/product-burn-time-accordion.liquid). Starter Pack
              // replays this for a pre-checked default refill (see below);
              // bundle mode's row initialises from the pre-checked radio
              // on its own connect.
              this.dispatchRefillChanged(event.target);
            });

            const checkedRefill = this.refillDrawer.querySelector('input[type="radio"]:checked');
            if (checkedRefill) this.syncCardImage(this.refillImageWrap, checkedRefill.dataset.productImage);
          }

          // Starter Pack: a holder/refill can now be pre-checked on load
          // (the section's "Build your set defaults" settings), but the
          // rows keyed to them (summary/shipping ship date, production
          // timetable, Scent Notes) only react to the change events — so
          // replay them once for the pre-checked radios. Deferred until
          // DOMContentLoaded so listeners in later sections are defined.
          // Bundle mode doesn't need this: its holder is the page product
          // and the Burn time row reads its pre-checked refill on connect.
          if (this.isStarterPack) {
            const replayDefaults = () => {
              const checkedHolder = this.holderDrawer && this.holderDrawer.querySelector('input[type="radio"]:checked');
              if (checkedHolder) this.dispatchHolderChanged(checkedHolder);
              const checkedRefill = this.refillDrawer && this.refillDrawer.querySelector('input[type="radio"]:checked');
              if (checkedRefill) this.dispatchRefillChanged(checkedRefill);
            };
            if (document.readyState === 'loading') {
              document.addEventListener('DOMContentLoaded', replayDefaults, { once: true });
            } else {
              setTimeout(replayDefaults, 0);
            }
          }

          if (this.form) this.form.addEventListener('submit', (event) => this.handleSubmit(event));

          this.updateGating();
        }

        dispatchHolderChanged(input) {
          document.dispatchEvent(
            new CustomEvent('candle-holder:changed', {
              detail: {
                url: input.dataset.productUrl,
                shipDate: input.dataset.shipDate || null,
                availabilityNote: input.dataset.availabilityNote || null,
              },
            })
          );
        }

        dispatchRefillChanged(input) {
          document.dispatchEvent(new CustomEvent('candle-refill:changed', { detail: { variantId: input.value } }));
        }

        bindDrawer(drawer) {
          if (!drawer) return;
          drawer.querySelectorAll('input[type="radio"]').forEach((input) => {
            input.addEventListener('change', () => this.updateGating());
          });
        }

        // "bundle" mode: the Build your set grid only shows while
        // "subscribe" is checked, and the button reads "Secure yours"
        // whenever it does. Only rewrites labels still showing the old
        // default, so an in-flight "Adding…" label is left alone (it
        // restores to defaultAddLabel afterwards).
        syncAddLabel() {
          if (this.dataset.purchaseMode !== 'bundle') return;
          const label = this.isSubscribing() ? this.dataset.secureLabel : this.dataset.addLabel;
          if (!label || label === this.defaultAddLabel) return;
          const previous = this.defaultAddLabel;
          this.defaultAddLabel = label;
          // Lime button price while it reads "Secure yours" (product-simple-purchase.liquid).
          this.addButtons.forEach((button) => button.toggleAttribute('data-secure-yours', label === this.dataset.secureLabel));
          this.addLabels.forEach((el) => {
            if (el.textContent === previous) el.textContent = label;
          });
        }

        isSubscribing() {
          return this.purchaseOptionInputs.some((input) => input.checked && input.value === 'subscribe');
        }

        syncSellingPlan() {
          if (!this.sellingPlanInput) return;
          // Keep the plan id current with the chosen frequency (when the
          // picker is present), then enable the field only while
          // "Subscribe" is active — a disabled control is omitted from both
          // native submission and the cart-drawer's FormData add, so
          // "One-time" sends no plan.
          if (this.frequencySelect) this.sellingPlanInput.value = this.frequencySelect.value;
          this.sellingPlanInput.disabled = !this.isSubscribing();
          this.updateSubscribePrice();
        }

        updateSubscribePrice() {
          // Follow the Subscribe option's headline price to the frequency
          // the customer picked. All plans currently share one discount so
          // this is usually a no-op, but it keeps the figure honest if the
          // plans ever diverge.
          if (!this.subscribePriceEl || !this.frequencySelect) return;
          const option = this.frequencySelect.selectedOptions[0];
          if (option && option.dataset.priceHtml) this.subscribePriceEl.innerHTML = option.dataset.priceHtml;
        }

        // Snapshot each card image's server-rendered markup (before any
        // syncCardImage swap) so resetSelections() can restore it.
        rememberCardImages(wraps) {
          this.cardImageDefaults = this.cardImageDefaults || new Map();
          wraps.forEach((wrap) => {
            if (wrap && !this.cardImageDefaults.has(wrap)) this.cardImageDefaults.set(wrap, wrap.innerHTML);
          });
        }

        // After a successful add, clear every Build-your-set choice back to
        // its server-rendered default: drawer radios + trigger labels, card
        // images, purchase option, gift bag, quantity. Otherwise the browser
        // restores the checked radios when the customer comes back to the
        // page (e.g. from checkout) while the trigger labels, images and
        // prices — all JS-driven — come back at their "Choose" defaults.
        resetSelections() {
          const drawers = this.isRefillBundle
            ? this.refillBundleDrawers.map((entry) => entry.drawer)
            : [this.holderDrawer, this.refillDrawer, this.discoverySetDrawer, document.getElementById('gift-option-drawer')];
          drawers.forEach((drawer) => {
            if (drawer && typeof drawer.reset === 'function') drawer.reset();
          });

          this.cardImageDefaults.forEach((html, wrap) => {
            wrap.classList.remove('product-purchase__build-your-set-image--loading');
            wrap.innerHTML = html;
          });

          if (this.form) {
            this.form.querySelectorAll('input[name="quantity"]').forEach((input) => {
              input.value = input.defaultValue;
            });
          }

          if (this.isRefillBundle) {
            this.refillBundleDrawers.forEach(({ wrap, drawer }) => {
              const checked = drawer.querySelector('input[type="radio"]:checked');
              if (checked) this.syncCardImage(wrap, checked.dataset.productImage);
            });
            this.updateRefillBundleGating();
            return;
          }

          this.purchaseOptionInputs.forEach((input) => {
            input.checked = input.defaultChecked;
          });

          const giftBagSelect = this.querySelector('[data-gift-bag-select]');
          if (giftBagSelect) {
            Array.from(giftBagSelect.options).forEach((option) => {
              option.selected = option.defaultSelected;
            });
          }

          // Re-apply whatever is still checked by default (bundle mode
          // pre-selects the first refill) and tell the dynamic accordion
          // rows — a null url/variantId hides them again.
          const checkedHolder = this.holderDrawer && this.holderDrawer.querySelector('input[type="radio"]:checked');
          if (this.holderDrawer) {
            if (checkedHolder) this.syncCardImage(this.holderImageWrap, checkedHolder.dataset.productImage);
            document.dispatchEvent(
              new CustomEvent('candle-holder:changed', {
                detail: {
                  url: checkedHolder ? checkedHolder.dataset.productUrl : null,
                  shipDate: checkedHolder ? checkedHolder.dataset.shipDate || null : null,
                  availabilityNote: checkedHolder ? checkedHolder.dataset.availabilityNote || null : null,
                },
              })
            );
          }

          const checkedRefill = this.refillDrawer && this.refillDrawer.querySelector('input[type="radio"]:checked');
          if (this.refillDrawer) {
            if (checkedRefill) this.syncCardImage(this.refillImageWrap, checkedRefill.dataset.productImage);
            document.dispatchEvent(
              new CustomEvent('candle-refill:changed', { detail: { variantId: checkedRefill ? checkedRefill.value : null } })
            );
          }

          this.updateGating();
        }

        hasSelection(drawer) {
          return Boolean(drawer && drawer.querySelector('input[type="radio"]:checked'));
        }

        // Whether the drawer offers anything selectable at all (a missing
        // drawer, or one whose every option is sold out, can never be
        // satisfied — the tooltip says "unavailable" instead of "choose").
        hasChoice(drawer) {
          return Boolean(drawer && drawer.querySelector('input[type="radio"]:not(:disabled)'));
        }

        formatList(items) {
          if (typeof Intl !== 'undefined' && Intl.ListFormat) {
            return new Intl.ListFormat(document.documentElement.lang || 'en', { type: 'conjunction' }).format(items);
          }
          return items.join(', ');
        }

        // Gates every add button on `reason` (empty = ready) and puts that
        // reason in the button's tooltip (product-simple-purchase.liquid).
        setDisabledReason(reason) {
          this.addButtons.forEach((button) => {
            const tooltip = button.parentElement.querySelector('[data-add-to-cart-tooltip]');
            if (tooltip) tooltip.textContent = reason;

            if (reason) {
              button.setAttribute('aria-disabled', 'true');
              if (tooltip) button.setAttribute('aria-describedby', tooltip.id);
            } else {
              button.removeAttribute('aria-disabled');
              button.removeAttribute('aria-describedby');
              if (tooltip) tooltip.removeAttribute('data-visible');
            }
          });
        }

        // Touch has no hover, so a tap on the disabled button flashes the
        // tooltip for a few seconds instead.
        flashDisabledReason() {
          clearTimeout(this.tooltipTimer);
          this.addButtons.forEach((button) => {
            const tooltip = button.parentElement.querySelector('[data-add-to-cart-tooltip]');
            if (tooltip && tooltip.textContent) tooltip.setAttribute('data-visible', '');
          });
          this.tooltipTimer = setTimeout(() => {
            this.addButtons.forEach((button) => {
              const tooltip = button.parentElement.querySelector('[data-add-to-cart-tooltip]');
              if (tooltip) tooltip.removeAttribute('data-visible');
            });
          }, 3000);
        }

        syncCardImage(wrap, src) {
          if (!wrap || !src) return;

          let img = wrap.querySelector('img');
          if (!img) {
            img = document.createElement('img');
            img.loading = 'lazy';
            wrap.appendChild(img);
          }

          // Ignore a swap to the image that's already showing.
          if (img.dataset.currentSrc === src) return;
          img.dataset.currentSrc = src;

          // The Liquid-rendered img ships a responsive srcset/sizes; drop
          // them so the single swapped-in src is what actually renders.
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');

          // Keep the current frame on screen (blurred, with a light sweep —
          // see the --loading CSS) while the next image decodes off-DOM,
          // then swap it in already-painted so there's no blank flash.
          wrap.classList.add('product-purchase__build-your-set-image--loading');

          const settle = () => {
            // A newer selection may have superseded this one mid-decode.
            if (img.dataset.currentSrc !== src) return;
            img.src = src;
            img.alt = '';
            wrap.classList.remove('product-purchase__build-your-set-image--loading');
          };

          const loader = new Image();
          loader.src = src;
          if (loader.decode) {
            loader.decode().then(settle, settle);
          } else if (loader.complete) {
            settle();
          } else {
            loader.addEventListener('load', settle, { once: true });
            loader.addEventListener('error', settle, { once: true });
          }
        }

        updateGating() {
          // Each required step, in on-page order. Starter Pack bundles the
          // refill AND the Discovery Set under BOTH options ("one-time" adds
          // them without a subscription), so both are always required there;
          // bundle mode only needs them while subscribing.
          const steps = [];
          if (this.isStarterPack) {
            steps.push({
              label: this.dataset.labelPurchaseOption,
              ready: this.purchaseOptionInputs.some((input) => input.checked),
            });
            steps.push({ label: this.dataset.labelCandleHolder, drawer: this.holderDrawer });
          }
          if (this.isStarterPack || this.isSubscribing()) {
            steps.push({ label: this.dataset.labelCandleRefill, drawer: this.refillDrawer });
            steps.push({ label: this.dataset.labelDiscoverySet, drawer: this.discoverySetDrawer });
          }

          const missing = steps.filter((step) => ('drawer' in step ? !this.hasSelection(step.drawer) : !step.ready));
          const unavailable = missing.find((step) => 'drawer' in step && !this.hasChoice(step.drawer));
          let reason = '';
          if (unavailable) {
            reason = this.dataset.disabledUnavailable.replace('[item]', unavailable.label);
          } else if (missing.length) {
            reason = this.dataset.disabledMissing.replace('[items]', this.formatList(missing.map((step) => step.label)));
          }

          this.setDisabledReason(reason);
          this.syncAddLabel();

          this.updateOneTimePrice();
          this.updateExperiencePrice();
          this.updateExtraLargePricing();
          this.updateSavingsBadge();
        }

        formatMoney(cents) {
          return window.MoneyFormat.format(cents);
        }

        updateOneTimePrice() {
          // Starter Pack only: the "One-time" option's price is the running
          // total of the items pending add-to-cart — chosen holder + chosen
          // refill + chosen Discovery Set at full retail. Until all three
          // are picked, fall back to the default stamped in the markup
          // ($304). The Extra-Large
          // Starter Pack never uses a live total — its price is a flat
          // two-tier figure owned by updateExtraLargePricing() instead.
          if (!this.oneTimePriceEl || this.isExtraLargeStarterPack) return;

          const holderInput = this.holderDrawer && this.holderDrawer.querySelector('input[type="radio"]:checked');
          const refillInput = this.refillDrawer && this.refillDrawer.querySelector('input[type="radio"]:checked');
          const discoverySetInput = this.discoverySetDrawer && this.discoverySetDrawer.querySelector('input[type="radio"]:checked');
          const holderPrice = holderInput ? Number(holderInput.dataset.variantPrice) : NaN;
          const refillPrice = refillInput ? Number(refillInput.dataset.variantPrice) : NaN;
          const discoverySetPrice = discoverySetInput ? Number(discoverySetInput.dataset.variantPrice) : NaN;

          const fallback = Number(this.oneTimePriceEl.dataset.oneTimeDefault) || 0;
          const total = Number.isFinite(holderPrice) && Number.isFinite(refillPrice) && Number.isFinite(discoverySetPrice)
            ? holderPrice + refillPrice + discoverySetPrice
            : fallback;

          this.oneTimePriceEl.textContent = this.formatMoney(total);
          this.syncExperienceCompare();
        }

        syncExperienceCompare() {
          // Starter Pack only: keep the Candle Experience option's
          // struck-through price equal to the "One-time" option's price.
          if (!this.experienceComparePriceEl || !this.oneTimePriceEl) return;
          this.experienceComparePriceEl.textContent = this.oneTimePriceEl.textContent;
        }

        updateExperiencePrice() {
          // Regular Starter Pack only: show the chosen holder's own Candle
          // Experience price (its data-build-your-set-price, from the
          // build_your_set.price metafield), falling back to the SSR default
          // when nothing is picked or that holder has no metafield.
          if (!this.hasHolderExperiencePrice || !this.experiencePriceEl) return;

          const holderInput = this.holderDrawer && this.holderDrawer.querySelector('input[type="radio"]:checked');
          this.experiencePriceEl.textContent =
            (holderInput && holderInput.dataset.buildYourSetPrice) || this.dataset.experiencePriceDefault;
        }

        parseMoney(text) {
          const amount = Number(String(text).replace(/[^0-9.]/g, ''));
          return Number.isFinite(amount) ? Math.round(amount * 100) : NaN;
        }

        updateSavingsBadge() {
          // Starter Pack only: the Candle Experience badge's [savings_percent] figure
          // (savings-badge.liquid) = Candle Experience vs One-time price,
          // rounded down, recomputed from the option prices as they change.
          // Hidden when the saving is zero / negative or a price is missing.
          if (!this.isStarterPack || !this.experiencePriceEl || !this.oneTimePriceEl) return;

          const experience = this.parseMoney(this.experiencePriceEl.textContent);
          const oneTime = this.parseMoney(this.oneTimePriceEl.textContent);
          const percent = experience > 0 && oneTime > 0 ? Math.floor(((oneTime - experience) * 100) / oneTime) : 0;

          this.querySelectorAll('[data-savings-badge]').forEach((badge) => {
            badge.hidden = percent <= 0;
            badge.querySelectorAll('[data-savings-percent]').forEach((el) => {
              el.textContent = `${percent}%`;
            });
          });
        }

        updateExtraLargePricing() {
          // Extra-Large Starter Pack only: both option prices are a flat
          // two-tier presentational figure keyed by whether the chosen
          // holder is Blue Onyx — never a live computed total, and never
          // affected by the refill choice. Re-run on every holder change
          // (called from updateGating, alongside every other drawer/option
          // change) so switching holders flips the price immediately.
          if (!this.isExtraLargeStarterPack) return;

          const holderInput = this.holderDrawer && this.holderDrawer.querySelector('input[type="radio"]:checked');
          const isPremium = Boolean(holderInput && holderInput.dataset.productHandle === this.blueOnyxHandle);

          // Skips silently when data-experience-price-base is absent — a
          // merchant purchase_experience_price section-setting override is
          // active, and that SSR-rendered value must not be touched.
          if (this.experiencePriceEl && this.dataset.experiencePriceBase) {
            this.experiencePriceEl.textContent = isPremium
              ? this.dataset.experiencePricePremium
              : this.dataset.experiencePriceBase;
          }
          if (this.oneTimePriceEl) {
            this.oneTimePriceEl.textContent = isPremium
              ? this.dataset.oneTimePricePremium
              : this.dataset.oneTimePriceBase;
            this.syncExperienceCompare();
          }
        }

        handleSubmit(event) {
          if (this.addButton.getAttribute('aria-disabled') === 'true') {
            event.preventDefault();
            this.flashDisabledReason();
            return;
          }

          if (this.isRefillBundle) {
            event.preventDefault();
            this.submitRefillBundle();
            return;
          }

          if (!this.isStarterPack && !this.isSubscribing()) return;

          event.preventDefault();
          this.submitBundle();
        }

        // Shared by submitBundle and submitRefillBundle: disables the
        // add-to-cart button(s), posts the given items to /cart/add.js, and
        // restores the button(s) when the request settles either way. A
        // bundle is all-or-nothing, so if any one item would take the cart
        // past its stock (window.StockLimits) nothing is added.
        postCartAdd(items) {
          const stockIssue = window.StockLimits && window.StockLimits.check(items);
          if (stockIssue) {
            this.addLabels.forEach((label) => window.StockLimits.flash(label, stockIssue.message));
            return Promise.resolve();
          }

          this.addButtons.forEach((button) => (button.disabled = true));
          this.addLabels.forEach((label) => (label.textContent = this.dataset.addingLabel));

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items, sections: 'header' }),
          })
            .then((response) => {
              if (!response.ok) throw new Error('Add to cart failed');
              return response.json();
            })
            .then((data) => {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
              this.resetSelections();
            })
            .catch(() => {})
            .finally(() => {
              this.addButtons.forEach((button) => (button.disabled = false));
              this.addLabels.forEach((label) => (label.textContent = this.defaultAddLabel));
            });
        }

        initRefillBundle() {
          this.form = this.closest('form');
          this.addButtons = Array.from(this.querySelectorAll('[data-add-to-cart-button]'));
          this.addButton = this.addButtons[0];
          this.addLabels = this.addButtons.map((button) => button.querySelector('[data-add-to-cart-label]'));
          this.addLabel = this.addLabels[0];
          this.defaultAddLabel = this.addLabel.textContent;

          // Each "Candle Refill" card's image wrap names its own drawer's id
          // directly (data-refill-bundle-image="candle-refill-bundle-drawer-N")
          // — three independent selections, unlike the single shared
          // data-refill-image used by "bundle"/"starter_pack".
          this.refillBundleDrawers = Array.from(this.querySelectorAll('[data-refill-bundle-image]'))
            .map((wrap) => ({ wrap, drawer: document.getElementById(wrap.dataset.refillBundleImage) }))
            .filter((entry) => entry.drawer);
          this.rememberCardImages(this.refillBundleDrawers.map((entry) => entry.wrap));

          this.refillBundleDrawers.forEach(({ wrap, drawer }) => {
            drawer.addEventListener('change', (event) => {
              if (event.target.type !== 'radio') return;
              this.syncCardImage(wrap, event.target.dataset.productImage);
              this.updateRefillBundleGating();
            });

            const checked = drawer.querySelector('input[type="radio"]:checked');
            if (checked) this.syncCardImage(wrap, checked.dataset.productImage);
          });

          if (this.form) this.form.addEventListener('submit', (event) => this.handleSubmit(event));

          this.updateRefillBundleGating();
        }

        updateRefillBundleGating() {
          const missing = this.refillBundleDrawers.filter((entry) => !this.hasSelection(entry.drawer));
          let reason = '';
          if (this.refillBundleDrawers.length === 0 || missing.some((entry) => !this.hasChoice(entry.drawer))) {
            reason = this.dataset.disabledUnavailable.replace('[item]', this.dataset.labelCandleRefill);
          } else if (missing.length) {
            reason = this.dataset.disabledRefills.replace('[count]', this.refillBundleDrawers.length);
          }

          this.setDisabledReason(reason);
        }

        submitRefillBundle() {
          const quantity = Number(this.form.querySelector('input[name="quantity"]').value) || 1;

          // Tag each refill with a hidden line item property (underscore
          // prefix = not shown to the customer) identifying it as added
          // through this interface, so a discount Function can find and
          // validate these lines specifically.
          const items = this.refillBundleDrawers.map(({ drawer }) => {
            const checked = drawer.querySelector('input[type="radio"]:checked');
            return checked ? { id: checked.value, quantity, properties: { _candle_refill_bundle: 'true' } } : null;
          });
          if (items.some((item) => !item)) return;

          this.postCartAdd(items);
        }

        submitBundle() {
          const quantity = Number(this.form.querySelector('input[name="quantity"]').value) || 1;
          const items = [];

          if (this.isStarterPack) {
            const holderInput = this.holderDrawer && this.holderDrawer.querySelector('input[type="radio"]:checked');
            if (!holderInput) return;
            items.push({ id: holderInput.value, quantity });
          } else {
            const holderIdField = this.form.querySelector('input[name="id"], select[name="id"]');
            items.push({ id: holderIdField.value, quantity });
          }

          if (this.isSubscribing()) {
            const refillInput = this.refillDrawer && this.refillDrawer.querySelector('input[type="radio"]:checked');
            const discoverySetInput = this.discoverySetDrawer && this.discoverySetDrawer.querySelector('input[type="radio"]:checked');
            if (!refillInput || !discoverySetInput) return;

            // Add the refill ON a selling plan so the cart line shows as a
            // subscription. Starter Pack and stone holder pages (except
            // gift-experience holders): every scent maps to a variant of
            // the same candle-refill-starterpack (or 470g) product, so its
            // plan is fixed once on the form (data-refill-selling-plan, the
            // "Candle experience starter pack" group). Collection-sourced
            // cards (refill_product unavailable, or a gift-experience
            // holder) carry their own plan instead (data-selling-plan, from
            // that candle-refill product's "Candle refill subscription"
            // group). Falls back to one-time if neither is available.
            // A gift-experience holder (data-gift-experience="true") is a one-time
            // gift, so its refill never goes on a plan.
            const refillItem = { id: refillInput.value, quantity: 1 };
            const refillSellingPlan = refillInput.dataset.sellingPlan || this.dataset.refillSellingPlan;
            if (refillSellingPlan && this.dataset.giftExperience !== 'true') refillItem.selling_plan = refillSellingPlan;
            items.push(refillItem);

            items.push({ id: discoverySetInput.value, quantity: 1 });
          } else if (this.isStarterPack) {
            // "One-time": bundle the same items as "The Candle Experience"
            // (holder + refill + discovery set), but add the refill variant
            // as a plain one-time line — no selling plan / subscription.
            const refillInput = this.refillDrawer && this.refillDrawer.querySelector('input[type="radio"]:checked');
            const discoverySetInput = this.discoverySetDrawer && this.discoverySetDrawer.querySelector('input[type="radio"]:checked');
            if (!refillInput || !discoverySetInput) return;
            items.push({ id: refillInput.value, quantity: 1 });
            items.push({ id: discoverySetInput.value, quantity: 1 });
          }

          // A gift bag armed via the "It's a gift?" drawer — its Save button
          // stamps data-gift-armed / data-gift-message on the drawer element.
          // Added one-time (no selling plan) with the note carried as a
          // visible "with personal message" line item property. Stays
          // optional: it's bundled only when armed and never gates add-to-cart.
          const giftDrawer = document.getElementById('gift-option-drawer');
          const giftBagVariant = this.dataset.giftBagVariant;
          if (giftBagVariant && giftDrawer && giftDrawer.dataset.giftArmed === 'true') {
            const giftMessage = (giftDrawer.dataset.giftMessage || '').trim();
            const giftProperties = {};
            if (giftMessage) giftProperties['with personal message'] = giftMessage;
            items.push({ id: giftBagVariant, quantity: 1, properties: giftProperties });
          }

          // Tag every product added through the Build-your-set / Starter Pack
          // grid with a hidden line item property (underscore prefix = not
          // shown to the customer in cart/checkout/emails) so these composed
          // adds are identifiable on the order. Per-item properties set above
          // (the gift bag's "with personal message") are merged on top.
          // Gift-experience bundles also carry `_gift_experience` so the
          // bundle discount Function can tell them apart: their refill is
          // one-time, not on a selling plan like the Candle Experience's.
          const bundleProperties = { _starter_pack: 'true' };
          if (this.dataset.giftExperience === 'true') bundleProperties._gift_experience = 'true';
          const bundledItems = items.map((item) => ({
            ...item,
            properties: { ...bundleProperties, ...(item.properties || {}) },
          }));

          // "Do you want a gift bag?" dropdown — "Yes" adds the gift bag
          // one-time (no selling plan). Pushed AFTER the _starter_pack
          // tagging on purpose: the gift bag is full price ($6) and must not
          // be picked up by any bundle discount keyed on that property.
          const giftBagSelect = this.querySelector('[data-gift-bag-select]');
          if (giftBagVariant && giftBagSelect && giftBagSelect.value === 'yes') {
            bundledItems.push({ id: giftBagVariant, quantity: 1 });
          }

          this.postCartAdd(bundledItems);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-scent-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-drawer')) {
    class ProductDrawer extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-drawer-close]').forEach((el) => {
          el.addEventListener('click', () => this.close());
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.close();
        });

        this.choiceInputs = Array.from(this.querySelectorAll('input[type="radio"][data-choice-label]'));
        this.choiceInputs.forEach((input) => {
          input.addEventListener('change', () => {
            this.syncTriggerLabel();
            this.close();
          });
        });
        this.syncTriggerLabel();
      }

      syncTriggerLabel() {
        const checked = this.choiceInputs.find((input) => input.checked);

        document.querySelectorAll(`[data-drawer-open="${this.id}"]`).forEach((trigger) => {
          const label = trigger.querySelector('[data-drawer-choice-label]');
          if (!label) return;
          // Remember the server-rendered placeholder ("Choose") the first
          // time through, so reset() can put it back.
          if (label.dataset.defaultLabel == null) label.dataset.defaultLabel = label.textContent;
          label.textContent = checked && checked.dataset.choiceLabel
            ? checked.dataset.choiceLabel
            : label.dataset.defaultLabel;
        });
      }

      // Put every radio back to its server-rendered default (usually
      // nothing checked; a pre-selected card stays selected) and resync the
      // trigger label. Called by <product-purchase-form> after a successful
      // add to cart, so the browser has no stale selection to restore when
      // the customer navigates back to the page. Drawers with extra state
      // of their own (the gift drawer) listen for `drawer:reset`.
      reset() {
        this.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = input.defaultChecked;
        });
        this.syncTriggerLabel();
        this.dispatchEvent(new CustomEvent('drawer:reset'));
      }

      open(trigger) {
        this.triggerElement = trigger || null;
        this.inert = false;
        this.setAttribute('open', '');
        document.body.style.overflow = 'hidden';
        const closeButton = this.querySelector('.product-scent-drawer__close');
        if (closeButton) closeButton.focus();
      }

      close() {
        this.inert = true;
        this.removeAttribute('open');
        document.body.style.overflow = '';
        if (this.triggerElement) this.triggerElement.focus();
      }
    }

    customElements.define('product-drawer', ProductDrawer);
  }

  if (!window.productDrawerTriggersBound) {
    window.productDrawerTriggersBound = true;
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-drawer-open]');
      if (!trigger) return;
      const drawer = document.getElementById(trigger.dataset.drawerOpen);
      if (drawer && typeof drawer.open === 'function') drawer.open(trigger);
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-shipping-info"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-shipping-info')) {
    customElements.define(
      'product-shipping-info',
      class ProductShippingInfo extends HTMLElement {
        connectedCallback() {
          this.row = this.querySelector('[data-free-shipping-row]');
          this.form = document.getElementById(this.dataset.formId);
          // The Starter Pack has a second (synced) checkout row; the first
          // button's price is the same figure.
          this.price = this.form ? this.form.querySelector('add-to-cart-price') : null;
          if (!this.row || !this.price) return;

          this.threshold = Number(this.dataset.threshold) || 0;
          this.update = this.update.bind(this);
          this.observer = new MutationObserver(this.update);
          this.observer.observe(this.price, { subtree: true, childList: true, characterData: true });
          // Quantity stepper buttons set the value without an `input` event.
          this.form.addEventListener('change', this.update);
          this.form.addEventListener('input', this.update);
          this.form.addEventListener('click', this.update);
          this.update();
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          if (this.form) {
            this.form.removeEventListener('change', this.update);
            this.form.removeEventListener('input', this.update);
            this.form.removeEventListener('click', this.update);
          }
        }

        update() {
          // Let the stepper / price element finish their own updates first.
          requestAnimationFrame(() => {
            const current = this.price.querySelector('.price__current') || this.price;
            const text = current.textContent.trim();
            // Empty button price (e.g. Starter Pack before every pick is
            // made) — leave the row as it is rather than flicker it off.
            if (!text) return;
            const unit = Math.round((Number(text.replace(/[^0-9.]/g, '')) || 0) * 100);
            const quantityInput = this.form.querySelector('[name="quantity"]');
            const quantity = Math.max(1, parseInt(quantityInput ? quantityInput.value : 1, 10) || 1);
            this.row.hidden = unit * quantity < this.threshold;
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-simple-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('add-to-cart-price')) {
    customElements.define(
      'add-to-cart-price',
      class AddToCartPrice extends HTMLElement {
        connectedCallback() {
          const button = this.closest('button');
          this.form = button ? button.form : null;

          if (this.dataset.priceSource === 'options') {
            // Mirror the checked purchase option's price. The option prices
            // are rewritten in place by <product-purchase-form> (holder +
            // refill total, holder experience price, Extra-Large tiers,
            // frequency), so observe the fieldset rather than hooking each.
            const purchaseForm = this.closest('product-purchase-form');
            this.options = purchaseForm ? purchaseForm.querySelector('.product-purchase__options') : null;
            if (!this.options) return;
            this.options.addEventListener('change', () => this.renderFromOption());
            // "Do you want a gift bag?" = Yes adds the gift bag to the same
            // cart add, so its price joins the button figure.
            this.purchaseForm = purchaseForm;
            this.giftBagPrice = Number(purchaseForm.dataset.giftBagPrice) || 0;
            this.giftBagSelect = purchaseForm.querySelector('[data-gift-bag-select]');
            if (this.giftBagSelect) this.giftBagSelect.addEventListener('change', () => this.renderFromOption());
            this.observer = new MutationObserver(() => this.renderFromOption());
            this.observer.observe(this.options, { subtree: true, childList: true, characterData: true });
            this.renderFromOption();
            return;
          }

          if (!this.dataset.variantPrices || !this.form) return;
          try {
            this.variantPrices = JSON.parse(this.dataset.variantPrices);
          } catch (error) {
            return;
          }
          this.onFormChange = (event) => {
            if (event.target.name === 'id') this.renderFromVariant();
          };
          this.form.addEventListener('change', this.onFormChange);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          if (this.onFormChange && this.form) this.form.removeEventListener('change', this.onFormChange);
        }

        renderFromVariant() {
          const field = this.form.elements.namedItem('id');
          const html = field ? this.variantPrices[field.value] : null;
          if (html != null) this.innerHTML = html;
        }

        // Option prices come in two shapes: snippets/price.liquid markup
        // (.price__compare / .price__current) or the Candle Experience's
        // plain figures ([data-experience-compare-price] /
        // [data-experience-price]). Normalise both to price.liquid markup.
        renderFromOption() {
          const checked = this.options.querySelector('.product-purchase__option-input:checked');
          const option = checked ? checked.closest('.product-purchase__option') : null;
          const priceEl = option ? option.querySelector('.product-purchase__option-price') : null;
          if (!priceEl) {
            this.replaceChildren();
            return;
          }

          const compareEl = priceEl.querySelector('.price__compare, [data-experience-compare-price]');
          const currentEl = priceEl.querySelector('.price__current, [data-experience-price]') || priceEl;
          let current = currentEl.textContent.trim();
          let compare = compareEl ? compareEl.textContent.trim() : '';
          if (!current) {
            this.replaceChildren();
            return;
          }

          // The gift bag is only bundled by submitBundle(): always on the
          // Starter Pack, and under "The Candle Experience" on holder pages
          // (one-time there is a native single-product add). Added to the
          // struck-through figure too so the saving shown stays the same.
          const addsGiftBag =
            this.giftBagPrice > 0 &&
            this.giftBagSelect &&
            this.giftBagSelect.value === 'yes' &&
            this.purchaseForm.dataset.giftBagVariant &&
            (this.purchaseForm.dataset.purchaseMode === 'starter_pack' || checked.value === 'subscribe');
          let isFree = currentEl.classList.contains('price__current--free');
          if (addsGiftBag) {
            current = this.formatMoney(this.parseMoney(current) + this.giftBagPrice);
            if (compare) compare = this.formatMoney(this.parseMoney(compare) + this.giftBagPrice);
            isFree = false;
          }

          const wrapper = document.createElement('span');
          wrapper.className = 'price';
          if (compare && compare !== current) {
            wrapper.classList.add('price--on-sale');
            const s = document.createElement('s');
            s.className = 'price__compare';
            s.textContent = compare;
            wrapper.appendChild(s);
          }
          const currentSpan = document.createElement('span');
          currentSpan.className = 'price__current';
          if (isFree) currentSpan.classList.add('price__current--free');
          currentSpan.textContent = current;
          wrapper.appendChild(currentSpan);

          if (this.innerHTML !== wrapper.outerHTML) this.replaceChildren(wrapper);
        }

        // Displayed figure ("$149", "€1.234,50", "FREE") -> cents.
        parseMoney(text) {
          return window.MoneyFormat.parse(text);
        }

        // Same format as <product-purchase-form>'s formatMoney (money_without_trailing_zeros, active currency).
        formatMoney(cents) {
          return window.MoneyFormat.format(cents);
        }
      }
    );
  }

  if (!customElements.get('quantity-selector')) {
    customElements.define(
      'quantity-selector',
      class QuantitySelector extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('.product-purchase__quantity-input');
          this.increaseButton = this.querySelector('[data-quantity-increase]');
          this.stockNote = document.getElementById(this.dataset.stockNote);
          this.querySelector('[data-quantity-decrease]').addEventListener('click', () => this.step(-1));
          this.increaseButton.addEventListener('click', () => this.step(1));

          this.form = this.input.form;
          this.input.addEventListener('change', () => this.applyLimit());
          if (this.form) {
            this.form.addEventListener('change', (event) => {
              if (event.target.name === 'id') this.applyLimit();
            });
            // Capture so the value is clamped before any other submit
            // handler (product-purchase-form, cart-drawer) reads it, and so
            // a blocked submit is already defaultPrevented for them.
            this.form.addEventListener(
              'submit',
              (event) => {
                const remaining = this.applyLimit();
                if (remaining !== null && remaining <= 0) {
                  event.preventDefault();
                  event.stopImmediatePropagation();
                }
              },
              true
            );
          }
          document.addEventListener('stock-limits:changed', () => this.applyLimit());

          this.applyLimit();
        }

        selectedVariantId() {
          const field = this.form ? this.form.elements.namedItem('id') : null;
          return field && field.value ? field.value : null;
        }

        // How many more of the selected variant can be added, or null when
        // it isn't stock-limited.
        remaining() {
          const variantId = this.selectedVariantId();
          if (!variantId || !window.StockLimits) return null;
          return window.StockLimits.remaining(variantId);
        }

        // Clamps the input to what's left. Shows the stock note when the
        // customer asked for more than that (typed past it, or pressed +
        // at the cap); hides it once they're back under the cap.
        applyLimit(requested = Number(this.input.value)) {
          const remaining = this.remaining();
          const min = Number(this.input.min) || 1;
          let value = Math.max(min, Number(this.input.value) || min);

          if (remaining === null) {
            this.input.removeAttribute('max');
          } else {
            this.input.max = Math.max(min, remaining);
            value = Math.min(value, Math.max(min, remaining));
          }

          if (String(value) !== this.input.value) {
            this.input.value = value;
            this.input.dispatchEvent(new Event('change', { bubbles: true }));
          }

          const atCap = remaining !== null && value >= remaining;
          if (atCap) {
            this.increaseButton.setAttribute('aria-disabled', 'true');
          } else {
            this.increaseButton.removeAttribute('aria-disabled');
          }

          if (remaining !== null && remaining > 0 && requested > remaining) {
            this.showStockNote(remaining);
          } else if (!atCap || remaining === null || remaining <= 0) {
            this.hideStockNote();
          }

          const stockIssue =
            remaining !== null && remaining <= 0
              ? window.StockLimits.check([{ id: this.selectedVariantId(), quantity: 1 }])
              : null;
          this.syncAddButtons(stockIssue ? stockIssue.message : null);
          return remaining;
        }

        showStockNote(remaining) {
          if (!this.stockNote) return;
          const inCart = window.StockLimits.inCart(this.selectedVariantId());
          const template = inCart > 0 ? this.dataset.onlyMoreAvailable : this.dataset.onlyAvailable;
          this.stockNote.textContent = template.replace('[quantity]', remaining).replace('[in_cart]', inCart);
          this.stockNote.hidden = false;
        }

        hideStockNote() {
          if (this.stockNote) this.stockNote.hidden = true;
        }

        syncAddButtons(message) {
          if (!this.form) return;
          Array.from(document.querySelectorAll('[data-add-to-cart-button]'))
            .filter((button) => button.form === this.form)
            .forEach((button) => {
              const label = button.querySelector('[data-add-to-cart-label]');
              if (message) {
                if (!button.hasAttribute('data-stock-limited')) {
                  button.dataset.stockLimited = label ? label.textContent : '';
                }
                button.disabled = true;
                if (label) label.textContent = message;
              } else if (button.hasAttribute('data-stock-limited')) {
                button.disabled = false;
                if (label) label.textContent = button.dataset.stockLimited;
                delete button.dataset.stockLimited;
              }
            });
        }

        step(direction) {
          const min = Number(this.input.min) || 1;
          const requested = Math.max(min, (Number(this.input.value) || min) + direction);
          const max = this.input.max ? Number(this.input.max) : Infinity;
          this.input.value = Math.min(max, requested);
          this.applyLimit(requested);
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-summary"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('.product-summary__rating');
    if (!link) return;

    const reviews = document.getElementById('judgeme_product_reviews');
    if (!reviews) return;

    event.preventDefault();
    reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Arriving from another page's rating link (e.g. the candle holder
  // drawer's cards link to `{url}#judgeme_product_reviews`): the browser's
  // own hash jump fires before lazy images/app blocks above the widget have
  // settled, so it can land short. Re-scroll once everything has loaded.
  if (window.location.hash === '#judgeme_product_reviews') {
    const scrollToReviews = () => {
      document.getElementById('judgeme_product_reviews')?.scrollIntoView({ block: 'start' });
    };
    if (document.readyState === 'complete') {
      scrollToReviews();
    } else {
      window.addEventListener('load', scrollToReviews, { once: true });
    }
  }

  // Gift card template only: product-gift-card-denomination-picker.liquid
  // dispatches this on every denomination change, since `product.price`
  // (what this price line renders server-side) only reflects the variant
  // selected at page load, not later clicks.
  // Starter Pack only: the "Made to order / Ships …" row here and the ship
  // date in product-shipping-info.liquid follow the stone picked in the
  // candle holder drawer (product-purchase-options.liquid sends that holder's
  // formatted `custom.preorder_date` as `shipDate`). `[data-holder-ship-date]`
  // holds the label with a `[date]` placeholder. A stone without a date
  // shows its `candle_holder.preorder_and_delivery` note in the summary
  // instead (`availabilityNote`, pre-rendered HTML). No pick hides both.
  document.addEventListener('candle-holder:changed', (event) => {
    const shipDate = event.detail && event.detail.shipDate;
    const availabilityNote = event.detail && event.detail.availabilityNote;
    document.querySelectorAll('[data-holder-ship-date-row]').forEach((row) => {
      const label = row.matches('[data-holder-ship-date]') ? row : row.querySelector('[data-holder-ship-date]');
      if (label && shipDate) label.textContent = label.dataset.holderShipDate.replace('[date]', shipDate);
      row.hidden = !shipDate;
    });
    document.querySelectorAll('.product-summary [data-holder-availability-note]').forEach((note) => {
      const showNote = !shipDate && Boolean(availabilityNote);
      note.innerHTML = showNote ? availabilityNote : '';
      note.hidden = !showNote;
    });
  });

  document.addEventListener('gift-card-denomination:changed', (event) => {
    const priceEl = document.querySelector('.product-summary__price');
    if (!priceEl) return;
    priceEl.textContent = event.detail.formattedPrice;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-to-top"] && !Shopify.designMode) return;
  try {
    if (!window.scrollToTopHandler) {
    window.scrollToTopHandler = true;
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-scroll-to-top]');
      if (!button) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let top = 0;
      const form = document.querySelector('.product__form');
      if (form && window.matchMedia('(max-width: 749px)').matches) {
        const headerHeight =
          parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        top = Math.max(0, form.getBoundingClientRect().top + window.scrollY - headerHeight - 16);
      }
      window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["slider-dots"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('slider-dots')) {
    customElements.define(
      'slider-dots',
      class SliderDots extends HTMLElement {
        connectedCallback() {
          this.trackSelector = this.dataset.trackSelector || '[data-track]';
          this.cardSelector = this.dataset.cardSelector || '.product-card';
          this.navLabel = this.dataset.navLabel || 'Slide __N__';
          this.maxDots = parseInt(this.dataset.maxDots, 10) || 12;
          this.totalItems = parseInt(this.dataset.totalItems, 10) || 0;
          this.scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth';

          this.n = 0;
          this.step = 0;
          this.maxScrollLeft = 0;
          this.cycling = false;
          this.dotCount = 0;

          this.onScroll = this.onScroll.bind(this);
          this.onResize = this.refresh.bind(this);

          this.resolveTrack(6);
        }

        disconnectedCallback() {
          if (this.rafId) cancelAnimationFrame(this.rafId);
          if (this.track) this.track.removeEventListener('scroll', this.onScroll);
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.mutationObserver) this.mutationObserver.disconnect();
        }

        // The track sits in a sibling subtree, so walk up to the section
        // root and query from there. Retries a few frames in case this
        // element upgrades before the track is in the DOM, then gives up
        // quietly (the section's own arrows still navigate).
        resolveTrack(retries) {
          const root = this.closest('[data-slider-dots-root]');
          this.track = root ? root.querySelector(this.trackSelector) : null;

          if (!this.track) {
            if (retries > 0) requestAnimationFrame(() => this.resolveTrack(retries - 1));
            return;
          }

          this.refresh();
          this.track.addEventListener('scroll', this.onScroll, { passive: true });

          // Re-measure whenever the track's box changes. Observing the track
          // (not window) also covers the case where it starts life zero-sized
          // — e.g. inside a tab panel that's display:none until its tab is
          // selected — and only gets a real size once shown. Viewport resizes
          // land here too, since the track's width follows the viewport.
          this.resizeObserver = new ResizeObserver(this.onResize);
          this.resizeObserver.observe(this.track);

          // Rebuild when the card set changes: featured-collection appends
          // pages of cards as you scroll near the end; related-products
          // swaps the whole track once its async recommendations fetch
          // resolves. Both land as childList mutations on the track.
          this.mutationObserver = new MutationObserver(() => this.refresh());
          this.mutationObserver.observe(this.track, { childList: true });
        }

        getCards() {
          return Array.from(this.track.querySelectorAll(this.cardSelector));
        }

        // Re-read the track geometry, decide how many bars to show, then let
        // refresh() sync the DOM. Runs on connect, card-set changes, and
        // resize — the numbers it reads only move when cards are added or
        // removed or the viewport resizes, so it stays out of the per-frame
        // scroll path.
        measure() {
          const cards = this.getCards();
          this.n = cards.length;

          if (this.n < 2) {
            this.step = 0;
            this.maxScrollLeft = 0;
            this.dotCount = 0;
            return;
          }

          // Average left-edge stride between cards — even for the whole row,
          // robust to a single odd gap. Rect-based, so independent of which
          // ancestor is the cards' offsetParent.
          const first = cards[0].getBoundingClientRect().left;
          const last = cards[this.n - 1].getBoundingClientRect().left;
          this.step = (last - first) / (this.n - 1);
          this.maxScrollLeft = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);

          // Cap + cycle from the true item count when the host gave one (a
          // lazily-paginated track hasn't rendered every card yet),
          // otherwise from what's on the page now.
          const known = this.totalItems || this.n;
          this.cycling = known > this.maxDots;
          this.dotCount = this.cycling ? this.maxDots : this.n;
        }

        refresh() {
          // A host may call this before the track has resolved (e.g. right
          // after filtering cards); nothing to sync until it has.
          if (!this.track) return;
          this.measure();

          // Hidden unless the track overflows and there are 2+ bars to show.
          if (this.dotCount < 2 || this.maxScrollLeft <= 1) {
            this.hidden = true;
            this.replaceChildren();
            return;
          }
          this.hidden = false;

          if (this.childElementCount !== this.dotCount) {
            // Keep the keyboard user on the same bar across a rebuild — the
            // card set can change under them (a page loads, the async
            // recommendations swap in).
            const focusedIndex = Array.from(this.children).indexOf(document.activeElement);

            const dots = Array.from({ length: this.dotCount }, (_, i) => {
              const dot = document.createElement('button');
              dot.type = 'button';
              dot.className = 'slider-dots__dot';
              dot.setAttribute('aria-label', this.navLabel.replace('__N__', i + 1));
              dot.addEventListener('click', () => this.goTo(i));
              return dot;
            });
            this.replaceChildren(...dots);

            if (focusedIndex > -1) {
              (this.children[focusedIndex] || this.lastElementChild).focus();
            }
          }

          this.updateActive();
        }

        // Which card sits at the start of the viewport. Exact because the
        // host cards are start-snapped and evenly stepped.
        leadingIndex() {
          if (this.step <= 0) return 0;
          const i = Math.round(this.track.scrollLeft / this.step);
          return Math.min(Math.max(i, 0), this.n - 1);
        }

        onScroll() {
          if (this.rafId) return;
          this.rafId = requestAnimationFrame(() => {
            this.rafId = null;
            this.updateActive();
          });
        }

        updateActive() {
          const dots = Array.from(this.children);
          if (!dots.length) return;

          const scrollLeft = this.track.scrollLeft;
          let activeIndex;

          if (this.cycling) {
            // Repeating indicator: the leading card's position within its
            // group of `maxDots`. No end pin — it just keeps cycling.
            activeIndex = this.leadingIndex() % this.maxDots;
          } else if (scrollLeft <= 1) {
            activeIndex = 0;
          } else if (scrollLeft >= this.maxScrollLeft - 1) {
            activeIndex = dots.length - 1;
          } else {
            activeIndex = Math.min(this.leadingIndex(), dots.length - 1);
          }

          dots.forEach((dot, i) => {
            const isActive = i === activeIndex;
            dot.classList.toggle('is-active', isActive);
            if (isActive) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        }

        goTo(index) {
          const card = this.getCards()[index];

          // A capped bar can point past the cards loaded so far (lazy
          // pagination) — scroll to the end, which loads more.
          if (!card) {
            this.track.scrollTo({ left: this.maxScrollLeft, behavior: this.scrollBehavior });
            return;
          }

          // Left-edge target for card `index`; start-snap settles exactly
          // here, so the highlight and the click agree.
          const target = Math.min(Math.max(index * this.step, 0), this.maxScrollLeft);
          this.track.scrollTo({ left: target, behavior: this.scrollBehavior });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
